<template>
  <section>
    <button class="button is-primary"
        @click="isCardModalActive = true">
        {{ $t('ui.ModalTerm.button_title') }}
    </button>
    <b-modal width="680px" :active.sync="isCardModalActive">
      <div class="card">
        <header class="card-header">
          <h1 style="text-align:center;">HRモンスター 利用規約</h1>
        </header>
        <div class="card-content">
          <div class="content" style="text-align:left !important;">
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第1条（利用規約の適用）</h4>
            <p style ="text-indent:1em;">株式会社robottte(以下「当社」という。)はHRモンスター利用規約（以下「本規約」という。）に基づき，HRモンスター(ロボシナリオ及びロボの作成・提供・運用を可能とするところの当社が提供するロボサービスを指し，以下「本サービス」という。)を利用者(当社と本サービスの利用契約を締結する法人を指し，以下「利用者」という)に対し提供する。</p>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第2条（契約の成立）</h4>
            <ol style ="text-indent:1em; margin-top:0px;">
              <li>本サービスの利用を希望する者が，当社所定の方法による申込を完了した時点で，当社は当該申込を承諾したものとし，本サービス利用契約（以下「本契約」という。)は成立する。<p style="margin:0px">なお，本サービス利用の申込を行った時点で，本サービスの利用を申し込んだ者(以下「申込者」という。)は本規約を異議なく承諾したものとみなし，本規約は本契約の内容の一部を構成する。</p><p>申込者は，利用者内において本サービスを利用する者に本規約を遵守させるものとする。</p></li>
              <li>前項にかかわらず，当社は自己の判断により，本サービス利用の申込の承諾を，申込があった日から契約期間内であればいつでも，撒回することができる。当社が承諾を撤回する場合には，書面又はメールアドレスにより申込者宛にその旨を通知し，当該通知をもって，本契約は申込時に遡って効力を失う。なお，当社は申込者に対して承諾を撤回した理由を説明する義務を負わないものとする。</li>
              <li>利用者は，第１項に定める申込の際に当社に通知した事項に変更が生じたときは，一週間以内に当社に通知しなければならない。</li>
            </ol>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第3条（契約の履行）</h4>
            <ol style="margin-bottom:0px; text-indent:1em; margin-top:0px;">
              <li>当社は善良なる管理者の注意をもって本サービスを利用者に提供し，利用者は本契約に従い本サービスを利用することができる。</li>
              <li>利用者は，本サービスにより作成・提供されるロボアプリケーションの利用権を，利用者と本サービスの利用契約を締結する者（以下「チャット利用者」という。)に対し再許諾することができる。利用者は，チャット利用者に対して本サービスの利用権を再許諾するときは，本規約に基づき当該チャット利用者との間で当該利用権の再許諾に関する契約を締結することとする。</li>
              <li>利用者は，本サービス及びこれを利用して得た情報については，自己の判断と貢任により利用するものとする。</li>
              <li>当社は，いかなる場合においても，本サービスについて以下の事項を保証しない。</li>
            </ol>     
            <ul style="margin-top:0px; margin-left:1em; list-style:none;">
              <li>（１）利用者の特定の使用目的に合致すること</li>
              <li>（２）利用者の期待する機能を有すること</li>
              <li>（３）利用者の期待する成果を実現すること</li>
              <li>（４）信頼性・利用可能性・再現性(同一のリクエストに対し同一の結果を<p style="text-indent:2em; margin-bottom:0px;">生じること)を有すること</p></li>
              <li>（５）利用者のニーズに応える性能・品質を備えていること</li>
              <li>（６）応答が正確性・妥当性を有すること</li>
              <li>（７）不具合や中断を起こさないこと</li>
              <li>（８）著作権，商標権，特許権等の知的財産権その他の第三者の権利を侵害<p style="text-indent:2em; margin-bottom:0px;">しないこと</p></li>
            </ul>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第4条（有効期間）</h4>
            <p style ="text-indent:1em;">本契約の有効期間は，利用者の選択に応じて、利用者が本サービスの利用を開始した日から６か月間、１２か月間または利用者の選択した別の期間とする。ただし，有効期間満了日の１か月前までに当社及び利用者いずれからも特段の意思表示がないときは，当該利用者が選択している有効期間と同一の期間延長されるものとし，以後も同様とする。
              また、利用者が本サービスに追加オプションを申し込んだ場合、追加オプションの契約開始日から新たな契約期間が適用されるものとし、追加オプションの契約期間は本契約の残存期間に追加されるものとする。具体的には、追加オプションの契約開始日から１年間が適用されるものとする。
            </p>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第5条（本規約の変更）</h4>
            <p style ="text-indent:1em;">当社は，利用者からの承諾を得ることなく，当社ホームページ内に本規約を掲載して公表することにより，本規約の内容を随時変更できる。なお，利用者は，変更後に本サービスを利用したことをもって，変更後の本規約に同意したものとみなす。</p>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第6条（ユーザーID及びパスワード）</h4>
            <p style ="text-indent:1em;">利用者は，当社が利用者に対して付与する本サービス利用に関するユーザーID（以下「ユーザーID」という。)，及び利用者が設定する本サービス利用に関するパスワード（以下「パスワード」という。）を第三者に開示，貸与，共有せず，第三者に漏洩することのないよう厳重に管理（パスワードの適宜変更を含む)する。ユーザーID及びパスワードの管理不備，使用上の過誤，第三者の使用等により利用者またはその他の者が損害を彼った場合，全て利用者がその賠償の責を負い，当社は何らの責任も負わない。ユーザーID及びパスワードの利用行為は，すべて当該ユーザーIDが付与された利用者及び当該パスワードを設定した利用者によるものとみなす。</p>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第7条（本サービス利用に必要な環境準備，維持）</h4>
            <p style ="text-indent:1em;">利用者は，自己の費用と責任において，本サービスを利用するために必要な設備，環境を準備・維持し，適切なセキュリティ対策を講じるものとする。</p>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第8条（禁止事項）</h4>
            <ol style="margin-bottom:0px;text-indent:1em; margin-top:0px;">
            <li>利用者は本サービスの利用に関して，次の行為を行わないものとする。</li>
            </ol>
            <ul style="margin-top:0px; margin-left:1em; margin-bottom:0px; list-style:none;">
              <li >（１）本サービスを利用して，当社もしくは第三者の著作権，商標権等の知<p style="text-indent:2em; margin-bottom:0px;">的財産権その他の権利を侵害すること，または侵害するおそれのある行為</p><p style="text-indent:2em; margin-bottom:0px;">をなすこと</p></li>
              <li>（２）本契約に違反して第三者に本サービスを利用させること</li>
              <li>（３）本サービスを利用して，法令もしくは公序良俗に違反し，当社もしくは第<p style="text-indent:2em; margin-bottom:0px;">三者に不利益を与える行為をなすこと</p></li>
              <li>（４）本サービスを利用して，当社もしくは第三者を差別もしくは誹諦中傷し，<p style="text-indent:2em; margin-bottom:0px;">またはその名誉もしくは信用を毀損すること</p></li>
              <li>（５）本サービスを利用して，詐欺等の犯罪行為をなすこと，または犯罪行為に<p style="text-indent:2em; margin-bottom:0px;">結びつくもしくは結びつくおそれがある行為をなすこと</p></li>
              <li>（６）当社もしくは第三者になりすまして本サービスを利用すること</li>
              <li>（７）本サービスを利用して，ウィルス等の有害なコンピュータプログラム等を<p style="text-indent:2em; margin-bottom:0px;">送信または掲載すること</p></li>
              <li>（８）本サービスを利用して，当社に無断で第三者に広告，宣伝もしくは勧誘の<p style="text-indent:2em; margin-bottom:0px;">メールを送信し(本サービスを広告，宣伝する行為を除く)，または第三者が</p><p style="text-indent:2em; margin-bottom:0px;">嫌悪感を抱く，もしくはそのおそれのあるメール(嫌がらせメール)を送信す<p style="text-indent:2em; margin-bottom:0px;">ること</p></li>
              <li>（９）本サービスを利用して，第三者の設備または本サービス用設備等の利用も<p style="text-indent:2em; margin-bottom:0px;">しくは運営に支障を与える行為，または与えるおそれのある行為をなすこと</p></li>
              <li>（10）本契約に規定する目的以外に本サービスを複製して使用し，また本サー<p style="text-indent:2em; margin-bottom:0px;">ビスの一部のみをインストール又は使用すること</p></li>
              <li>（11）本サービスを翻案，改変し，またはリバースエンジニアリング，逆コンパ<p style="text-indent:2em; margin-bottom:0px;">イル又は逆アセンブルすること</p></li>
              <li>（12）当社の設備に無権限でアクセスすること，過度な負担を与えること，設<p style="text-indent:2em; margin-bottom:0px;">備を不能にすることその他本サービスの提供及び運営に支障を与える行為を</p><p style="text-indent:2em; margin-bottom:0px;">すること</p></li>
              <li>（13）その他，当社が本サービスの利用者として相応しくないと判断する行為<p style="text-indent:2em; margin-bottom:0px;">をなすこと</p></li>
            </ul>
            <ol style="margin-top:0px;text-indent:1em;">
            <li value="2">前項に違反することにより，当社または第三者に損害を与えた場合，利用者は自らの費用と責任において解決するものとし，当社は一切の責任を負わない。</li>
            </ol>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第9条（個人情報）</h4>
            <ol style="text-indent:1em; margin-top:0px;">
              <li>当社は，利用者またはチャット利用者から提供される情報を以下に掲載する当社の個人情報保護方針等で最新のものに基づき，適切に取扱うものとする。<a href="https://hr-monster.io/privacy/" target=”_blank”>プライバシーポリシー</a></li>
              <li>利用者及びチャット利用者は，当社が，本サービスの提供に必要な範囲において，利用者の個人情報（個人情報の保護に関する法律（平成１５年５月３０日法律第５７号)第２条第１項に定めるものを指し，以下同じ)及び利用履歴を閲覧することことに同意する。</li>
            </ol>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第10条（データの取り扱い）</h4>
            <ol style="text-indent:1em; margin-top:0px;">
              <li>当社は，本サービス用設備（サーバ等）に蓄積，保存されるデータ及び利用者またはチャット利用者が本サービスの利用に関連して当社に提供した一切の情報（以下総称して「利用者データ」という。）について保存する責任を負わず，利用者は必要に応じ自らの責任でバックアップし保存しておくものとする。</li>
              <li>利用者は当社が利用者データ（個人情報を除く）の修正・削除要請に応じる義務を負わないことに同意する。</li>
              <li>利用者は，当社が本サービスの提供に必要な範囲において，利用者データに対し，アクセス，閲覧，編集，削除，複写，複製，ダウンロードすることに同意する。</li>
            </ol>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第11条（知的財産権の帰属）</h4>
            <p style="text-indent:1em;">本サービスの提供に関するすべての知的財産権（知的財産権を受ける権利を含む）は，当社に帰属するものとする。</p>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第12条（使用許諾）</h4>
            <ol style="text-indent:1em; margin-top:0px;">
              <li>当社は，利用者が本規約を遵守することを条件として，利用者に対して，本サービスを利用時においてのみ使用することのできる，非独占的かつ譲渡不能の本サービスの使用権を許諾する。</li>
              <li>利用者は，本サービスの使用にあたり，公序良俗に反する行為及び知的財産権その他第三者の権利を侵害しないように配慮するものとし，利用者による本サービスの使用により第三者との間で当該第三者の権利を侵害した又は侵害するおそれがあるとして紛争等が生じた場合は，利用者自身の責任と負担においてこれを解決するものとする。</li>
            </ol>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第13条（本サービスを利用したサービスの開始）</h4>
            <ol style="text-indent:1em; margin-top:0px;">
              <li>利用者は，本規約に定める条件に従い，本サービスを利用してチャット利用者に対しサービスを提供することができる。</li>
              <li>利用者は，チャット利用者に当社所定の利用条件を遵守させなければならず，チャット利用者との間で本規約に反する合意をすることはできない。</li>
              <li>第１項に基づく本サービスに関するチャット利用者の行為は，利用者の行為とみなされ，チャット利用者が当社所定の利用条件に違反したこと，その他チャット利用者によるサービスの利用に起因して損害が発生した場合であっても，利用者は自らの費用と責任において解決するものとし，当社は一切の責任を負わない。</li>
            </ol>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第14条（本サービスの提供の停止等）</h4>
            <ol style="margin-bottom:0px; text-indent:1em; margin-top:0px;">
              <li>当社は，利用者が次の事項に該当する場合，本サービスの提供を即時停止することができる。</li>
            </ol>
            <ul style="margin-top:0px; margin-left:1em; margin-bottom:0px; list-style:none;">
              <li>（１）本サービスの申込または申込の際の当社宛に通知した事項の変更時に，虚<p style="text-indent:2em; margin-bottom:0px;">偽の内容を通知したことが判明した場合</p></li>
              <li>（２）第８条に定める禁止事項を行った場合（チャット利用者が第８条に定める<p style="text-indent:2em; margin-bottom:0px;">禁止事項を行った場合も含む)</p></li>
              <li>（３）本サービスの料金について支払を遅延したとき</li>
              <li>（４）本サービスの利用にあたって，当社が不適切と判断する行為を行った場合<p style="text-indent:2em; margin-bottom:0px;">（チャット利用者が本サービスの利用にあたって，当社が不適切と判断する</p><p style="text-indent:2em; margin-bottom:0px;">行為を行った場合も含む)</p></li>
              <li>（５）その他本契約に違反した場合（チャット利用者が本契約に違反した場合を<p style="text-indent:2em; margin-bottom:0px;">含む）</p></li>
            </ul>
            <ol style="text-indent:1em;margin-top:0px;">
              <li value="2">当社は，事前の告知なく，本サービスの仕様・機能・画面の変更，及び本サービスの円滑な提供，改良，メンテナンスを目的として本サービスを停止することができる。</li>
              <li>前二項に基づき本サービスが停止された場合においても，利用者は当該停止期間に相当する本サービスの料金を支払うものとする。</li>
            </ol>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第15条（本サービスの提供廃止）</h4>
            <ol style ="text-indent:1em; margin-top:0px;">
              <li>当社は，１か月前までに利用者宛に書面で通知することにより，本サービスの全部または一部を廃止することができる。ただし，やむを得ない場合は，利用者宛の通知なくして本サービスを廃止することができる。</li>
              <li>前項に基づき本サービスの全部が廃止されたときは，本契約も自動的に無条件で解除され，終了する。当社は，利用者に対して，本サービスの廃止及び本項に基づく本契約の終了について，賠償金，補償金その他名目の如何を問わず金銭債務を負担せず，その他何らの債務も負担しない。</li>
              <li>前項にかかわらず，当社の都合により本サービスの全部または一部を廃止する場合，当社は，当該廃止日以降に相当するところの廃止対象の本サービスの料金(日割り計算)を利用者に対し請求しない。</li>
            </ol>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第16条（当社による本契約の解除）</h4>
            <ol style="margin-bottom:0px;text-indent:1em; margin-top:0px;">
              <li>当社は，利用者に次の各号の一に該当する事由が生じたときは，利用者に対する催告，通知その他の何らの手続を要することなく即時に本契約を解除することができる。</li>
            </ol>   
            <ul style="margin-top:0px; margin-left:1em; margin-bottom:0px;list-style:none;">
              <li>（１）本契約に違反（チャット利用者による本契約の違反を含む)し，相当の期<p style="text-indent:2em; margin-bottom:0px;">間を定めて催告したにもかかわらず，なお是正されないとき</p></li>
              <li>（２）第１４条第１項第１号，または第４号による本サービスの提供を停止され<p style="text-indent:2em; margin-bottom:0px;">てもなお１０日以内にその事由を是正しないとき</p></li>
              <li>（３）第１４条第１項第３号に該当したとき</li>
              <li>（４）本契約の履行に関し.重大な過失または背信行為があったとき</li>
              <li>（５）差押，仮差押，仮処分もしくは競売の申立てがあったとき，租税滞納処分<p style="text-indent:2em; margin-bottom:0px;">を受けたとき，または破産，民事再生，会社更生手続開始の申立てがあった</p><p style="text-indent:2em; margin-bottom:0px;">とき，もしくは清算に入ったとき</p></li>
              <li>（６）自ら振出し，もしくは引受けた手形または小切手を不渡とするとき，もし<p style="text-indent:2em; margin-bottom:0px;">くは支払停止状態にいたったとき</p></li>
              <li>（７）監督官庁より営業停止または営業免許もしくは営業登録の取消の処分を受<p style="text-indent:2em; margin-bottom:0px;">けたとき</p></li>
              <li>（８）事業の廃止もしくは重大な変更，または解散の決議をしたとき</li>
              <li>（９）その他本契約を継続し難い童大な事由が発生したと当社が判断したとき</li>
            </ul>
            <ol style ="text-indent:1em;margin-top:0px;">
              <li value="2">第１項による解除権の行使は，当社による利用者に対する損害賠償の請求を妨げない。</li>
              <li>第１項により本契約が解除された場合，利用者は解除された日の属する月の末日までに相当する本サービスの料金を支払うものとする。</li>
            </ol>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第17条（免責）</h4>
            <ol style="margin-bottom:0px;text-indent:1em; margin-top:0px;">
              <li>当社は，次に定める事項その他本サービスの利用に起因し，または本サービスに関連する事項により利用者が損害を被った場合といえども，一切の責任を負わない。</li>
            </ol>
            <ul style="margin-top:0px; margin-left:1em; margin-bottom:0px; list-style:none;">
              <li>（１）利用者が準備，維持する設備の性能または障害等による場合</li>
              <li>（２）電気通信事業者の責による場合</li>
              <li>（３）当社が定める利用手順，セキュリティ手段等を利用者が遵守しないことに<p style="text-indent:2em; margin-bottom:0px;">起因する場合</p></li>
              <li>（４）善良なる管理者の注意をもってしても防御し得ない本サービス用設備への<p style="text-indent:2em; margin-bottom:0px;">第三者による不正アクセスまたはアタック，通信経路上での傍受による場合</p></li>
              <li>（５）本サービスを利用することにより，利用者と第三者との間で生じた紛争等<p style="text-indent:2em; margin-bottom:0px;">による場合</p></li>
            </ul>
            <ol style="margin-bottom:0px;text-indent:1em; margin-top:0px;">
              <li value="2">本契約に別段の定めのない限り，利用者は，本サービスの停止，廃止，解除または解約による利用料金の返金を受けることはできない。</li>
              <li>利用者は，チャット利用者からの本サービスに関するクレーム，要望その他に対し自己の貢任と費用において対応するものとし，当社は責任を負わない。万一当該クレーム等により当社に損害が生じたときは，利用者は当社が被った損害を直ちに賠償するものとする。</li>
              <li>本サービスの提供に関して当社が損害賠償貢任を負う場合であっても，当社の責任は，当社の故意または重過失による直接の結果として現実に生じた通常の損害に限られ，逸失利益，間接損害，予見の有無を問わず特別損害は含まないものとする。</li>
            </ol>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第18条（利用料金）</h4>
            <ol style ="text-indent:1em; margin-top:0px;">
              <li>利用者は，別途規定する当社の定める支払条件及び価格表に従い，当社に対し本サービスの利用料金を支払う。</li>
              <li>月の途中で利用を開始または終了(解約，解除等終了原因を問わない）した場合，1ヶ月に満たない日数を1ヶ月間とみなすものとし，当社は利用料金の日割精算を行わない。</li>
              <li>利用者が利用料金の支払を怠ったとき，当社は，支払期日の翌日から完済に至るまで年１４．６％の割合による遅延損害金の支払を請求できるものとする。</li>
              <li>当社は，利用者に対する金銭債権を有するときは，いつでも利用者の自己に対する金銭債権と対当額にて相殺することができる。</li>
            </ol>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第19条（不可抗力）</h4>
            <p style ="text-indent:1em;">不可抗力による本契約の全部または一部（金銭債務を除く）の履行遅滞又は履行不能については，いずれの当事者も責任を負わない。</p>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第20条（反社会的勢力の排除）</h4>
            <ol style ="text-indent:1em; margin-top:0px;">
              <li>利用者及び当社は，自らが暴力団，暴力団員又はこれらに準ずる者等の反社会的勢力に該当しないことを表明し，保証する。</li>
              <li>利用者及び当社は，自らまたは第三者を利用して，暴力，脅迫，恐喝，威圧等の暴力的な要求行為，詐欺的な行為，業務を妨害する行為，名誉，信用等を毀損する行為，その他これらに準ずる行為を行わないことを表明し，保証する。</li>
              <li>利用者及び当社は，相手方が本条第１項または第２項に違反した場合，当該違反当事者に対する催告，通知その他の何らの手続を要することなく即時に本契約を解除することができる。なお，解除権の行使は，解除権を行使した当事者による当該違反当事者に対する損害賠償の請求を妨げない。</li>
              <li>第３項による契約解除によって，本条第１項または第２項に違反した当事者に損害が発生した場合でも，当該違反当事者は，解除権を行使した当事者に対して何ら損害賠償の請求を行わないものとする。</li>
              <li>利用者が第３項により本契約を解除した場合，当社は，当該解除日以降に相当する本サービスの料金を利用者に対し請求しない。</li>
              <li>当社が第３項による本契約を解除した場合においても，利用者は当該解除日の属する月の末日までに相当する本サービスの料金を支払うものとする。</li>
            </ol>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第21条（存続条項）</h4>
            <p style ="text-indent:1em;">第３条（契約の履行），第８条（禁止事項）第２項，第９条（個人情報)，第１０条(データの取扱い)，第１１条(知的財産権），第１３条(本サービスを利用したサービスの開始）第３項，第１７条（免責），第１９条(不可抗力)，本条，第２２条（準拠法）及び第２３条（合意管轄）の規定は，理由の如何を問わず本契約が終了した後においてもその効力を有する。</p>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第22条（準拠法）</h4>
            <p style ="text-indent:1em;">本契約は日本国の法律に準拠し，かつ同法に従って解釈されるものとする。</p>
            <h4 style="margin-top:1em; margin-bottom:0.5em;">第23条（合意管轄）</h4>
            <p style ="text-indent:1em;">本契約に関し，当事者間に紛争が生じた場合には，東京地方裁判所を第一審の専属的合意管轄裁判所とする。</p>
　          <p style="margin:0px">改訂履歴</p>
            <p style="margin:0px">２０１９年５月２８日制定</p>
            <p style="margin:0px">２０２１年８月１日 会社分割に伴い、第1条記載の社名を変更</p>
            <p style="margin:0px">２０２３年９月１９日 現状の運用に即し、第１６条記載の解約条項を削除</p>
            <p style="text-align:right;">以上</p>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
export default {
  name: 'ModalTerm',
  data () {
    return {
      isCardModalActive: false
    }
  }
}
</script>

<style scoped>
#login-modal {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  justify-content: center;
  align-items: center;
}
header {
  margin: 0;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  position: relative;
  height: 60px;
  padding: 10px;
  background: #489BE7;
  color: white;
  font-size: 30px;
  font-weight: 1000;
}
footer {
  margin: 0;
  justify-content: space-between;
}
.right {
  position: absolute;
  top: 0;
  right: 0;
}
.form {
  padding: 20px;
}
.body {
  width: 80%;
  max-width: 400px;
  color: #000;
  background: #fff;
  border-radius: 30px;
}
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.4s;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
}
.modal-enter-active .body,
.modal-leave-active .body {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.modal-enter .body,
.modal-leave-to .body {
  opacity: 0;
  transform: translateY(-100px);
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalTerm.vue